import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { OrderPayoutRequest, PayOutCancelRequest, PayOutReviewRequest } from "./api";
import { useUserId } from "@hooks/use-user-id";
import {
  applyOrderForPayout,
  cancelPayOutOrder,
  getPayoutOrders,
  payOutOrderReview,
  uploadReceipt,
} from "./slice";

export const usePayoutOrders = () => {
  const state = useAppSelector((state) => state.payoutOrders);
  const dispatch = useAppDispatch();
  const userId = useUserId();

  const getPayoutOrdersHandler = useCallback(
    (data: OrderPayoutRequest) => dispatch(getPayoutOrders({ userId, data })),
    [dispatch, userId]
  );

  const applyOrderForPayoutHandler = useCallback(
    (orderId: string) => dispatch(applyOrderForPayout({ orderId })),
    [dispatch]
  );

  const uploadReceiptHandler = useCallback(
    (orderId: string, file: FileList) =>
      dispatch(uploadReceipt({ orderId, file })),
    [dispatch]
  );

  const payOutOrderReviewHandler = useCallback(
    (data: PayOutReviewRequest) => dispatch(payOutOrderReview({ data })),
    [dispatch]
  );

  const cancelPayOutOrderHandler = useCallback(
    (orderId: string, data: PayOutCancelRequest) => dispatch(cancelPayOutOrder({ orderId, data })),
    [dispatch]
  );

  return {
    state,
    applyOrderForPayout: applyOrderForPayoutHandler,
    getPayoutOrders: getPayoutOrdersHandler,
    uploadReceipt: uploadReceiptHandler,
    payOutOrderReview: payOutOrderReviewHandler,
    cancelPayOutOrder: cancelPayOutOrderHandler,
  };
};
